import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {getImageUrlById} from "../actions/networkActions";
import {classNames} from "../utils/miscUtils";

function ExcursionTags(props) {
    const tags = useSelector(state => state.tags);
    const [showLegend, setShowLegend] = useState(false);

    return (
        <div className="relative">
            <ul className="text-grey-darker grow flex sm:block justify-between flex-wrap mr-4">
                {props.attributes.map((attribute, index) => (
                    <li key={index} className="flex items-center sm:mt-1">
                        {/* icon if exists */}
                        {tags && tags[attribute] &&
                            <img className="w-8 h-8 sm:w-4 sm:h-4 shrink-0" src={getImageUrlById(tags[attribute], {width: 64})} alt=""/>
                        }

                        {/* label*/}
                        <span className={classNames("hidden sm:inline",tags?.[attribute] ? "ml-1" : "ml-5")}>
                            {attribute}
                        </span>
                    </li>)
                )}

                <li className="sm:hidden">
                    <button className="action-button action-button-enabled" onClick={() => setShowLegend(!showLegend)}>?</button>
                </li>
            </ul>
            <div className="absolute  top-0 right-0">


            </div>
            
            {showLegend &&
            <div className="sm:hidden">
                {props.attributes.map(label =>
                    <div key={label} className="flex items-center my-1">
                        {tags && tags[label] && <img className="w-6 h-6 mr-2" src={getImageUrlById(tags[label], {width: 64})} alt=""/>}
                        {label}
                    </div>
                )}
            </div>
            }
        </div>
    )
}

export default ExcursionTags;
